import Image from "next/image";
import React from "react";
import LazyVideo from "./LazyVideoComponent";
import { isJSXElement } from "@utils/common";

export interface PageMainTitleCardProps {
    chipTitle?: string | JSX.Element;
    mainTitle: string | JSX.Element;
    description: string | JSX.Element;
    mediaType: "image" | "video";
    mediaUrl: string;
    mediaAltText?: string;
    posterUrl?: string;
    primaryButton: string | JSX.Element;
    secondaryButton?: string | JSX.Element;
    showKeyFeatures?: boolean;
    isArabic?: boolean;
    showKeyFeaturesPoint?: string[];
    scrollHandler?: () => void;
}
const PageMainTitleCard: React.FC<PageMainTitleCardProps> = (props) => {
    const {
        chipTitle,
        mainTitle,
        description,
        mediaType,
        mediaUrl,
        mediaAltText,
        posterUrl = "",
        primaryButton,
        secondaryButton,
        showKeyFeatures,
        showKeyFeaturesPoint = ["No setup fee", "No credit card required"],
        scrollHandler,
        isArabic,
    } = props;
    const handleButtonClick = () => {
        if (scrollHandler) {
            scrollHandler();
        }
    };
    return (
        <>
            <header className="max-w-6xl mx-auto px-4 lg:px-0 pt-4">
                <div className={`flex gap-7 flex-col ${isArabic ? "lg:flex-row-reverse" : "lg:flex-row"} justify-center md:justify-between lg:py-20 pt-0 mt-12 md:mt-0`}>
                    <div
                        className={`lg:w-1/2 w-full flex flex-col justify-center items-center lg:justify-center ${isArabic ? "lg:items-end" : "lg:items-start"} lg:pt-0 md:pt-16${
                            isArabic ? "lg:text-right" : "lg:text-left"
                        } text-center`}
                    >
                        {chipTitle &&
                            (isJSXElement(chipTitle) ? (
                                chipTitle
                            ) : (
                                <p className="px-3 py-1.5 rounded-full lg:text-base text-sm font-semibold text-green-700 bg-green-100 flex flex-row gap-2 items-center flex-nowrap whitespace-nowrap w-fit border border-solid border-green-700">
                                    {chipTitle}
                                    <Image height={24} width={24} src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg" alt="whatsapp icon" />
                                </p>
                            ))}
                        {isJSXElement(mainTitle) ? (
                            mainTitle
                        ) : (
                            <h1 className="flex flex-col lg:justify-start justify-center lg:pt-4 lg:text-3xl lg:font-bold text-2xl mt-10 md:mt-0 text-gray-600 md:text-left text-center">
                                {mainTitle}
                            </h1>
                        )}

                        {isJSXElement(description) ? (
                            description
                        ) : (
                            <p className={`lg:py-6 py-4 lg:text-base font-normal text-center ${isArabic ? "lg:text-right" : "lg:text-left"} lg:text-gray-500 text-gray-700`}>
                                {description}
                            </p>
                        )}

                        <div className={`flex lg:gap-6 gap-3 ${isArabic ? "ml-auto" : null}`}>
                            <div className="flex flex-col pt-4 lg:pt-0 md:flex-row  gap-4 justify-center md:justify-start">
                                {isJSXElement(primaryButton) ? (
                                    primaryButton
                                ) : (
                                    <button
                                        className="px-4 py-2 text-base font-medium text-white rounded-md focus:outline-none hover:shadow-lg bg-blue-500 hover:bg-blue-600 transition duration-300 ease-in-out"
                                        onClick={handleButtonClick}
                                    >
                                        {primaryButton}
                                    </button>
                                )}
                            </div>
                            {secondaryButton && (
                                <div className="flex flex-col pt-4 lg:pt-0 md:flex-row gap-4 justify-center md:justify-start">
                                    {isJSXElement(secondaryButton) ? (
                                        secondaryButton
                                    ) : (
                                        <button
                                            className="px-4 py-2 text-base font-medium rounded-md focus:outline-none hover:shadow-2xl transition duration-300 ease-in-out bg-white text-blue-500 border border-solid border-blue-500"
                                            onClick={handleButtonClick}
                                        >
                                            {secondaryButton}
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>

                        {showKeyFeatures && (
                            <div className={`${isArabic ? "ml-auto" : null} flex gap-4 px-2 lg:px-0 mt-6`}>
                                {showKeyFeaturesPoint.map((each) => {
                                    return (
                                        <div className="flex items-center gap-1 md:gap-2" key={each}>
                                            <Image
                                                width={21}
                                                height={21}
                                                src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                                alt="Green checkmark"
                                                className="flex-shrink-0"
                                            />
                                            <p className="head-points text-gray-400 whitespace-nowrap">{each}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <div className="lg:w-1/2 w-full md:flex md:justify-center overflow-hidden">
                        {mediaType === "image" ? (
                            <Image width={580} height={500} priority src={mediaUrl} alt={mediaAltText ?? ""} />
                        ) : (
                            <div className="relative left-0.5">
                                <LazyVideo src={mediaUrl} type="video/mp4" poster={posterUrl} />
                                <div className="h-full w-1 absolute top-0 bg-white" style={{ right: "-1px" }}></div>
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </>
    );
};

export default PageMainTitleCard;
